import { useRecoilValue } from "recoil";
import Layout from "../../../components/custom/Layout";
import useData from "./useData";
import { useAppContext } from "../../../context";
import VirtualTable from "../../../components/custom/VirtualTable";
import ModalManage from "./ModalManage";
import { useState } from "react";
import { ITempControllSetting } from "../../../globals/interfaces";

export default function TempControlManager () {

    const { user } = useAppContext();
    const { 
        data,
        selectedItem, 
        setSelectedItem,
        updateTempSetting 
    } = useData(user.s_unit, user.s_email);

    const [modal, setModal] = useState(false);

    const handleUpdate = (item: ITempControllSetting) => {
        setSelectedItem(item);
        setModal(true);
    }
    
    return (
        <Layout>
            <h3>Temperature Control Manager</h3>
            <VirtualTable 
                data={data || []}
                mapping={[{
                    name: 'Location',
                    value: 'location'
                }, {
                    name: 'Setting in °Celsius',
                    value: 'setting'
                }, {
                    name: 'Current in °Celsius',
                    value: 'tempVal',
                    number: true
                }, {
                    name: 'Recorded At',
                    value: 'tempDate',
                    datetime: true
                }]}
                handleClick={item => handleUpdate(item)}
            />
            <ModalManage 
                modal={modal}
                setModal={setModal}
                item={selectedItem}
                unit={user.s_unit}
                updateTempSetting={updateTempSetting}
            />
        </Layout>
    );
}